import { WizardStepId } from "../types";
import { WIZARD_DELAYS } from "../constants";

interface WelcomeStepDependencies {
  addUserMessage: (content: string) => void;
  addBotMessage: (
    content: string,
    options?: {
      wizardType?: "question" | "confirmation" | "error" | "component" | "info";
      delay?: number;
      actions?: Array<{
        label: string;
        onClick: () => void;
        variant?: "primary" | "secondary";
      }>;
    },
  ) => void;
  advanceToStep: (nextStep: WizardStepId, delay?: number) => void;
  setAwaitingUserInput: (value: boolean) => void;
  saveCooldown: () => void;
  setIsOpen: (value: boolean) => void;
  navigate: (
    options: { search: string },
    config?: { replace: boolean },
  ) => void;
  locationSearch: string;
  conversationStartedRef: React.MutableRefObject<boolean>;
}

export const startWelcomeConversation = (deps: WelcomeStepDependencies) => {
  const { addBotMessage } = deps;

  addBotMessage("Olá! 👋 Bem-vindo ao Easyfit!", {
    wizardType: "info",
    delay: WIZARD_DELAYS.SHORT,
  });

  setTimeout(() => {
    addBotMessage(
      "Sou seu assistente virtual e vou te ajudar a configurar seu perfil profissional em poucos minutos.",
      { wizardType: "info", delay: WIZARD_DELAYS.MEDIUM },
    );
  }, 1500);

  setTimeout(() => {
    addBotMessage(
      "Este processo vai levar cerca de 10 minutos e vai ajudar seus alunos a encontrarem você com facilidade.",
      {
        wizardType: "question",
        delay: WIZARD_DELAYS.MEDIUM,
        actions: [
          {
            label: "Sim, vamos lá! 🚀",
            onClick: () => handleWelcomeStart(deps),
            variant: "primary",
          },
          {
            label: "Fazer depois",
            onClick: () => handleSkipWizard(deps),
            variant: "secondary",
          },
        ],
      },
    );
  }, 3000);
};

export const handleWelcomeStart = (deps: WelcomeStepDependencies) => {
  const { addUserMessage, addBotMessage, advanceToStep, setAwaitingUserInput } =
    deps;

  addUserMessage("Sim, vamos lá! 🚀");

  setTimeout(() => {
    addBotMessage("Perfeito! Vamos começar com suas informações básicas. 📝", {
      wizardType: "info",
      delay: 600,
    });
  }, WIZARD_DELAYS.MEDIUM);

  setTimeout(() => {
    advanceToStep("profile_name", 0);

    setTimeout(() => {
      addBotMessage(
        "Primeiro, qual é o seu nome profissional? (Como você gostaria de ser chamado por seus alunos)",
        { wizardType: "question", delay: WIZARD_DELAYS.MEDIUM },
      );
      setAwaitingUserInput(true);
    }, WIZARD_DELAYS.LONG);
  }, 1800);
};

export const handleSkipWizard = (deps: WelcomeStepDependencies) => {
  const {
    addUserMessage,
    addBotMessage,
    saveCooldown,
    setIsOpen,
    navigate,
    locationSearch,
    conversationStartedRef,
  } = deps;

  addUserMessage("Vou fazer depois");

  setTimeout(() => {
    addBotMessage(
      "Sem problemas! Você pode retornar a qualquer momento para configurar seu perfil. Até logo! 👋",
      { wizardType: "info", delay: 600 },
    );
  }, WIZARD_DELAYS.MEDIUM);

  setTimeout(() => {
    saveCooldown();
    setIsOpen(false);
    const params = new URLSearchParams(locationSearch);
    params.delete("onboarding");
    navigate({ search: params.toString() }, { replace: true });
    conversationStartedRef.current = false;
  }, 2500);
};
